import {
  matchEventSubtypes,
  matchEventTypes,
} from "../mls-match-summary/utils";
import { statsApiCardTypes } from "../shared/utils";

export function formatPlayerSummaryData({ cards = [], goals = [] }) {
  const home = [];
  const away = [];

  const sortedGoalAndCardEvents = [...cards, ...goals].sort(sortByTime);

  sortedGoalAndCardEvents.forEach((keyEvent) => {
    if (keyEvent.type === matchEventTypes.own_goals) {
      if (keyEvent.event.team_role === "home") {
        away.push({ ...keyEvent.event, type: keyEvent.type });
      } else {
        home.push({ ...keyEvent.event, type: keyEvent.type });
      }

      return;
    }

    if (keyEvent.event.team_role === "home") {
      home.push({
        ...keyEvent.event,
        ...keyEvent.event.shot_at_goal,
        type: keyEvent.type,
      });
    } else {
      away.push({
        ...keyEvent.event,
        ...keyEvent.event.shot_at_goal,
        type: keyEvent.type,
      });
    }
  });

  return { home, away };
}

function getNoPenaltyGoals(goals) {
  return goals.filter(
    (goal) => goal.event.game_section !== matchEventSubtypes.penalty
  );
}

function getRedCards(cards) {
  return cards.filter(
    (card) =>
      card.event.card_color === statsApiCardTypes.red ||
      card.event.card_color === statsApiCardTypes.yellowRed
  );
}

function sortByTime(a, b) {
  return new Date(a.event.event_time) - new Date(b.event.event_time);
}
